import React, { useState, useEffect } from "react";
import {
  Button,
  Row,
  Col,
  InputGroup,
  Input,
  ButtonGroup,
  Modal,
  FormGroup,
  Label,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import CustomDataTable from "../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DailyStatReportServices from "../../services/OrderingServices/DailyStatReportServices";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const EmailConfigForm = ({ isOpen, toggle, selectedItem, fetchConfigs }) => {
  const [formData, setFormData] = useState({
    smtpServer: "",
    port: "",
    enableSsl: false,
    senderEmail: "",
    recipientEmail: "",
  });

  useEffect(() => {
    if (selectedItem) {
      setFormData(selectedItem);
    }
  }, [selectedItem]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // const handleSubmit = async () => {
  //   try {
  //     await EmailConfigurationService.update(selectedItem.id, formData);
  //     toast.success("Email configuration updated successfully");
  //     fetchConfigs();
  //     toggle();
  //   } catch (error) {
  //     toast.error("Failed to update configuration");
  //     console.error(error);
  //   }
  // };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      {" "}
      <div className="modal-header">
        {" "}
        <h5 className="modal-title">Edit Email Configuration</h5>{" "}
        <button
          type="button"
          className="close"
          onClick={toggle}
          aria-label="Close"
        >
          {" "}
          <span aria-hidden="true">×</span>{" "}
        </button>{" "}
      </div>{" "}
      <div className="modal-body">
        {" "}
        <FormGroup>
          {" "}
          <Label>SMTP Server</Label>{" "}
          <Input
            name="smtpServer"
            value={formData.smtpServer}
            onChange={handleChange}
          />{" "}
        </FormGroup>{" "}
        <FormGroup>
          {" "}
          <Label>Port</Label>{" "}
          <Input
            type="number"
            name="port"
            value={formData.port}
            onChange={handleChange}
          />{" "}
        </FormGroup>{" "}
        <FormGroup check>
          {" "}
          <Input
            type="checkbox"
            name="enableSsl"
            checked={formData.enableSsl}
            onChange={handleChange}
          />{" "}
          <Label check>Enable SSL</Label>{" "}
        </FormGroup>{" "}
        <FormGroup>
          {" "}
          <Label>Sender Email</Label>{" "}
          <Input
            name="senderEmail"
            value={formData.senderEmail}
            onChange={handleChange}
          />{" "}
        </FormGroup>{" "}
        <FormGroup>
          {" "}
          <Label>Recipient Email</Label>{" "}
          <Input
            name="recipientEmail"
            value={formData.recipientEmail}
            onChange={handleChange}
          />{" "}
        </FormGroup>{" "}
      </div>{" "}
      {/* <div className="modal-footer">
        {" "}
        <Button color="secondary" onClick={toggle}>
          Cancel{" "}
        </Button>{" "}
        <Button color="primary" onClick={handleSubmit}>
          Save{" "}
        </Button>{" "}
      </div>{" "} */}
    </Modal>
  );
};

const DailyStatReport = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState(false);

  const toggleFormModal = (item = null) => {
    setSelectedItem(item);
    setFormModalOpen(!formModalOpen);
  };

  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const response = await DailyStatReportServices.getList();
      setData(response || []);
    } catch (error) {
      toast.error("Failed to fetch email configurations");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigs();
  }, []);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      width: "75px",
    },
    {
      name: "Organization",
      selector: (row) => row.orgName || "N/A",
      sortable: true,
    },
    {
      name: "Contact",
      selector: (row) => row.orgContact || "-",
      sortable: true,
    },
    {
      name: "Sales Amount",
      selector: (row) => row.saleAmount,
      sortable: true,
    },
    {
      name: "VAT Amount",
      selector: (row) => row.vatAmount,
      sortable: true,
    },
    {
      name: "Total Transactions",
      selector: (row) => row.totalTransactions,
      sortable: true,
    },
  ];

  const filteredData = data.filter((row) =>
    `${row.smtpServer} ${row.senderEmail} ${row.recipientEmail}`
      .toLowerCase()
      .includes(filterText.toLowerCase())
  );

  return (
    <div className="page-content">
      {" "}
      <div className="container-fluid">
        {" "}
        <BreadCrumb title="Email Configurations" pageTitle="Settings" />
        <Row className="mb-2">
          <Col md={8} xs={12}>
            <InputGroup>
              <Input
                placeholder="Search by server, sender, or recipient"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </InputGroup>
          </Col>
        </Row>
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          customStyles={customStyles}
          progressComponent={
            <div className="my-3">
              <Triangle visible={true} height="80" width="80" color="#5B71B9" />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={filteredData}
        />
        <EmailConfigForm
          isOpen={formModalOpen}
          toggle={toggleFormModal}
          selectedItem={selectedItem}
          fetchConfigs={fetchConfigs}
        />
      </div>
    </div>
  );
};

export default DailyStatReport;
